import React from 'react';
import { useSearchParams } from 'react-router-dom';
import HeroMosaicPage from './HeroMosaicPage';
import './ShopifyThemePage.css';

// Storefront/theme data tools, one tab each. Add new theme features to TABS.
const TABS = [
  { id: 'hero-mosaic', label: 'Hero Mosaic', Component: HeroMosaicPage },
];

function ShopifyThemePage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const active = TABS.find((t) => t.id === searchParams.get('tab')) || TABS[0];
  const { Component } = active;

  return (
    <div className="shopify-theme-page">
      <div className="shopify-theme-header">
        <h1>Shopify Theme</h1>
        <p>Data the storefront theme reads from Shopify — metaobjects, metafields and scheduled homepage content.</p>
      </div>
      <div className="shopify-theme-tabs" role="tablist">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={tab.id === active.id}
            className={`shopify-theme-tab ${tab.id === active.id ? 'is-active' : ''}`}
            onClick={() => setSearchParams({ tab: tab.id })}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="shopify-theme-tab-body">
        <Component />
      </div>
    </div>
  );
}

export default ShopifyThemePage;
